/** @flow */
import { combineReducers } from "redux";
import department from "./department";
import employee from "./employee";
import manager from "./manager";
import { initialState as departmentReportReportingInitialState } from "./department/report";
import { initialState as departmentReportsReportingInitialState } from "./department/reports";
import { initialState as employeeReportReportingInitialState } from "./employee/report";
import { initialState as employeeReportsReportingInitialState } from "./employee/reports";
import { initialState as managerReportReportingInitialState } from "./manager/report";
import { initialState as managerReportsReportingInitialState } from "./manager/reports";

export const initialState = {
  department: {
    report: departmentReportReportingInitialState,
    reports: departmentReportsReportingInitialState,
  },
  employee: {
    report: employeeReportReportingInitialState,
    reports: employeeReportsReportingInitialState,
  },
  manager: {
    report: managerReportReportingInitialState,
    reports: managerReportsReportingInitialState,
  },
};

export default combineReducers({
  department,
  employee,
  manager,
});
